import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useAuth } from '../../../hooks/useAuth';
import { Storage } from '../../../utils/Storage';
import { selectUserDeleted } from '../../../store/settingsSlice';
import { selectUserDeletedFromLocations } from '../../../store/locationsSlice';

export default function UserDeletedHandler() {
    const { onLogout } = useAuth();

    const userDeletedFromSettings = useSelector(selectUserDeleted);
    const userDeletedFromLocations = useSelector(selectUserDeletedFromLocations);

    const hasHandledRef = useRef(false);

    useEffect(() => {
        if ((userDeletedFromSettings || userDeletedFromLocations) && !hasHandledRef.current) {
            hasHandledRef.current = true;

            Storage.setUserDeletedFlag();
            onLogout();
        }
    }, [userDeletedFromSettings, userDeletedFromLocations, onLogout]);

    return null;
}
